import { useEffect, useState } from 'react';
import { getRegulation, IRegulation } from 'services/regulation.service';
import { GiHamburgerMenu } from 'react-icons/gi';

import { BackToTop } from '../back-to-top';
import { useLocation } from 'react-router-dom';
import Collapsible from 'react-collapsible';

import { buildRegulationTopics, RegulationTopic } from './regulation-topics';

require('./styles.scss');
interface IRegulamentoContentProps {
  modal?: boolean;
  rede?: boolean;
  /** Esconde o sumário lateral. A página de Regras do rebranding não o tem. */
  semSumario?: boolean;
}

export function RegulamentoContent({ modal, rede, semSumario }: IRegulamentoContentProps) {
  const [regulation, setRegulation] = useState<IRegulation>();
  const [topicsRegulation, setTopicsRegulation] = useState<any>();
  const [isClicked, setIsClicked] = useState(false);
  const [hash, setHash] = useState<string>('');
  const [openCollapsibles, setOpenCollapsibles] = useState<Record<string, boolean>>({});

  const location = useLocation();

  const handleTriggerClick = (id: string) => {
    setOpenCollapsibles(prevState => ({
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    async function loadData() {
      const data = await getRegulation(rede);
      if (data) {
        const item = buildRegulationTopics(data.regulation_text);

        setRegulation({ ...data, regulation_text: item.html });
        setTopicsRegulation(item.titles);
      }
    }

    loadData();
  }, []);

  useEffect(() => {
    setHash(location.hash);
  }, [location]);

  function changeUrl(hashItem: string) {
    window.location.hash = hashItem;
    setHash(hashItem);
  }

  function hadleTopicsMenu(item: RegulationTopic) {
    if (!!item?.subtitles?.length && item.subtitles?.length > 0) {
      return (
        <Collapsible
          handleTriggerClick={() => handleTriggerClick(item.id)}
          open={openCollapsibles[item.id]}
          onOpen={() => changeUrl(`#${item.id}`)}
          trigger={item.title}
          key={item.id}
        >
          <ul>
            {item.subtitles.map((subItem: any, index: number) => (
              <li
                onClick={() => {
                  setIsClicked(false);
                }}
                className="mt-2 ml-4"
                key={subItem.id + '_' + index}
              >
                <a
                  className={`${
                    '#' + subItem.id === hash ? 'font-bold' : 'font-thin'
                  } hover:no-underline hover:text-white hover:font-bold active:text-white active:no-underline truncate w-full block`}
                  href={`#${subItem.id}`}
                  title={subItem.title}
                >
                  {subItem.title}
                </a>
              </li>
            ))}
          </ul>
        </Collapsible>
      );
    } else if (item.id && item.title && item.subtitles) {
      return (
        <p className="w-full m-0">
          <a
            className={`${'#' + item.id === hash && 'active-item'} menu-item truncate w-full block hover:no-underline`}
            key={item.id}
            href={`#${item.id}`}
            title={item.title}
            onClick={() => {
              setOpenCollapsibles({});
              setIsClicked(false);
            }}
          >
            {item.title}
          </a>
        </p>
      );
    }
  }

  if (!topicsRegulation && !regulation) return <h1>Carregando...</h1>;

  return (
    <>
      <div id="menu-regulamento" className="container flex">
        {!isClicked && !semSumario && (
          <button onClick={() => setIsClicked(!isClicked)} className="fixed lg:hidden top-20 left-5 bg-purple p-2">
            <GiHamburgerMenu size={20} />
          </button>
        )}

        {!semSumario && (
        <div
          className={`${modal ? 'p-2' : 'p-2 lg:p-8'}  ${isClicked ? 'w-full block' : 'hidden lg:block'} lg:w-[20%] rounded-l-lg`}
        >
          <div className={`${modal && 'overflow-y-auto h-[30vh]'} content-menu`}>
            <h3 className="text-lg mb-3">Estrutura de tópicos</h3>
            {topicsRegulation.map((item: any) => hadleTopicsMenu(item))}
          </div>
        </div>
        )}

        <div id="regulamento-content" className={`html text-lg text-white p-8 space-y-5 rounded-r-lg w-full ${semSumario ? '' : 'lg:w-[80%]'}`}>
          {/* {regulation?.regulation.url && (
            <a
              className="text-blue-600"
              href={regulation?.regulation.url}
              target="_blank"
              rel="noreferrer"
            >
              Clique aqui para baixar o PDF
            </a>
          )} */}

          {regulation?.regulation_text && <div dangerouslySetInnerHTML={{ __html: regulation.regulation_text }}></div>}
        </div>
      </div>
      <BackToTop />
    </>
  );
}
